export const INDICADOR_MONITOREOS = 'Monitoreos';
export const INDICADOR_VISITAS = 'Visitas de verificación';
export const INDICADOR_ESPECTACULARES = 1; // Vía pública
export const INDICADOR_M_I = 2; // Medios impresos
export const INDICADOR_INTERNET = 3; // Internet
export const INDICADOR_EVENTOS = 6; // Eventos de Apoyo ciudadano, Precampaña o Campaña'
export const INDICADOR_CASAS = 7; // Casas de Apoyo ciudadano, Precampaña o Campaña
export const INDICADOR_MOVIL = 11; // Móvil
export const INDICADOR_WEB = 12; // Web
